module.exports = __webpack_public_path__ + "img/type7.240ffb44.png";